<template>
  <bar-chart :chartdata="chartdata"/>
</template>

<script>
import BarChart from '@/components/charts/bar'

export default {
  name: 'BackupShelveryManagedChart',
  components: {
    BarChart
  },
  props: {
    managed: {
      type: Array,
      default: () => []
    },
    notConfigured: {
      type: Array,
      default: () => []
    },
    ignored: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      chartdata: null
    }
  },
  methods: {
    fillchartdata: function () {
      this.chartdata = {
        labels: [
          'ec2',
          'rds',
          'aurora',
          'volumes',
          'redshift',
          'documentdb'
        ],
        datasets: [
          {
            label: 'managed',
            backgroundColor: '#06d6a0',
            data: this.managed
          },
          {
            label: 'not configured',
            backgroundColor: '#ef476f',
            data: this.notConfigured
          },
          {
            label: 'ignored',
            backgroundColor: '#ffd166',
            data: this.ignored
          }
        ]
      }
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/BackupShelveryManagedChart.vue